<div class="header">

  <div class=" container justify-content-center">

    <div class="header-container">

      <div class="bbpay-logo">
          <img src="../assets/images/logo_bbpay.svg" alt="">
      </div>

    </div>

  </div>

</div>
